<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Charity Settlements List
        </h4>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th>Total Orders</th>
              <th>Total Charity Amount</th>
              <th>Month</th>
              <th>Year</th>
              <th>Date</th>
              <th>Status</th>
              <th>Status Update</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let val of donation">

              <td>{{ val.totalOrders }}</td>

              <td class="fw-bold">
                {{ currency }} {{ val.totalDonationAmount | number: '1.2-2' }}
              </td>

              <td>{{ val.month }}</td>
              <td>{{ val.year }}</td>
              <td>{{ val.created_at | date: 'medium' }}</td>
              <td>
                <span class="badge px-3 py-2 fw-semibold status-badge" [ngClass]="{
      'status-pending': val.status === 'pending',
      'status-processing': val.status === 'processing',
      'status-paid': val.status === 'paid'
    }">
                  {{ val.status | titlecase }}
                </span>
              </td>

              <!-- STATUS UPDATE -->
              <td>
                <!-- Action Buttons -->
                <div class="btn-group btn-group-sm" role="group">

                  <!-- Back to Pending (only from processing) -->
                  <button class="btn btn-outline-warning" *ngIf="val.status === 'processing'"
                    (click)="openConfirmModal(confirmStatusModal, val, 'pending')">
                    Pending
                  </button>

                  <!-- To Processing (only from pending) -->
                  <button class="btn btn-outline-info" *ngIf="val.status === 'pending'"
                    (click)="openConfirmModal(confirmStatusModal, val, 'processing')">
                    Processing
                  </button>

                  <!-- To Paid (from pending or processing) -->
                  <button class="btn btn-outline-success"
                    *ngIf="val.status === 'pending' || val.status === 'processing'"
                    (click)="openConfirmModal(confirmStatusModal, val, 'paid')">
                    Paid
                  </button>

                  <!-- Paid locked -->
                  <button class="btn btn-success" *ngIf="val.status === 'paid'" disabled>
                    ✔ Paid
                  </button>

                </div>
              </td>

              <!-- ACTIONS -->
              <td>
                <button class="btn btn-sm btn-primary m-1" (click)="viewDonationDetails(val)" ngbTooltip="View details">
                  <i class="fa fa-eye"></i>
                </button>
              </td>

            </tr>

            <tr *ngIf="donation?.length === 0 && !loading">
              <td colspan="8" class="text-center">No charity found</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="d-flex justify-content-center mt-5" *ngIf="donation?.length">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- CONFIRM STATUS MODAL -->
<ng-template #confirmStatusModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Confirm Status Change</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <p>
      Are you sure you want to change this transaction status to
      <b class="text-capitalize">{{ selectedStatus }}</b>?
    </p>

    <div *ngIf="selectedStatus === 'paid'" class="alert alert-warning mb-0">
      This action will mark the charity settlement as <b>PAID</b>. Please make sure payment is completed.
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-primary" (click)="confirmStatus(modal)">
      Yes, Confirm
    </button>
  </div>
</ng-template>